import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onUnmounted, shallowRef, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useNavItems } from '@/composables/UseSpeedNav'

// 2025.06.21 - BSU
// Vue complains about the :location binds above, but doesn't expose 'Anchor' type directly.
// type Anchor =
// 	| 'top left' | 'top center' | 'top right'
// 	| 'center left' | 'center center' | 'center right'
// 	| 'bottom left' | 'bottom center' | 'bottom right'
// 	| 'right center' | 'left center'


export default /*@__PURE__*/_defineComponent({
  __name: 'SpeedNav',
  setup(__props, { expose: __expose }) {
  __expose();

const open = shallowRef(false)
const fabPosition = shallowRef('absolute') // or 'fixed', 'app'
const fabLocation = shallowRef('center center') // or 'left center', etc
const menuLocation = shallowRef('right center') // or 'left center', etc
const transition = shallowRef('slide-x-transition') // or 'fade-transition', etc
const fabSize = shallowRef('large') // or 'medium', 'small', etc

const router = useRouter()
const items = useNavItems()

function go(to: any) {
	open.value = false
	router.push(to)
}

function onKeydown(e: KeyboardEvent) {
	// Ctrl + Alt + P
	if (e.ctrlKey && e.key.toLowerCase() === 'b') {
		e.preventDefault()
		open.value = !open.value
	}
}

onMounted(() => {
	//window.addEventListener('keydown', onKeydown)
})
onUnmounted(() => {
	//window.removeEventListener('keydown', onKeydown)
})

const __returned__ = { open, fabPosition, fabLocation, menuLocation, transition, fabSize, router, items, go, onKeydown }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})